import ConfigurazioneContabilitaTipoDocumentiListPage from "./pages/ConfigurazioneContabilitaTipoDocumentiListPage.vue";
import ConfigurazioneContabilitaCausaliTipoDocumentiListPage from "./pages/ConfigurazioneContabilitaCausaliTipoDocumentiListPage.vue";
import ContabilitaDocumentiListPage from "./pages/ContabilitaDocumentiListPage.vue";
import ContabilitaDocumentiEditPage from "./pages/ContabilitaDocumentiEditPage.vue";
import ContabilitaDocumentiViewPage from "./pages/ContabilitaDocumentiViewPage.vue";
import ConfigurazioneContabilitaTabellaIvaListPage from "./pages/ConfigurazioneContabilitaTabellaIvaListPage.vue";
import ConfigurazioneContabilitaMetodiPagamentoListPage from "./pages/ConfigurazioneContabilitaMetodiPagamentoListPage.vue";
import ConfigurazioneContabilitaSoggettiListPage from "./pages/ConfigurazioneContabilitaSoggettiListPage.vue";
import ConfigurazioneContabilitaSoggettiEditPage from "./pages/ConfigurazioneContabilitaSoggettiEditPage.vue";
// import ContabilitaSoggettoListPage from "./pages/ContabilitaSoggettoListPage.vue";
import ConfigurazioneContabilitaTipoSoggettoListPage from "./pages/ConfigurazioneContabilitaTipoSoggettoListPage.vue";
// import ContabilitaDocumentiListPage from "./pages/ContabilitaDocumentiListPage.vue";
// import ContabilitaFatturazioneView from "./pages/ContabilitaFatturazioneView.vue";
// import ContabilitaFatturazioneEdit from "./pages/ContabilitaFatturazioneEdit.vue";
// import TipiDocumentoList from "./components/TipiDocumentoList.vue";
// import TipiDocumentoView from "./components/TipiDocumentoView.vue";
// import TipiDocumentoEdit from "./components/TipiDocumentoEdit.vue";
// import CausaliDocumentoList from "./components/CausaliDocumentoList.vue";
// import CausaliDocumentoView from "./components/CausaliDocumentoView.vue";
// import CausaliDocumentoEdit from "./components/CausaliDocumentoEdit.vue";
// import FatturazioneNumeratoriList from "./components/FatturazioneNumeratoriList.vue";
// import FatturazioneNumeratoriView from "./components/FatturazioneNumeratoriView.vue";
// import FatturazioneNumeratoriEdit from "./components/FatturazioneNumeratoriEdit.vue";

// import ContabilitaDocumentiViewPage from "./pages/ContabilitaDocumentiViewPage.vue";
import ContabilitaSoggettoListPage from "./pages/ContabilitaSoggettoListPage.vue";
import ContabilitaSoggettoEditPage from "./pages/ContabilitaSoggettoEditPage.vue";
import ContabilitaSoggettoViewPage from "./pages/ContabilitaSoggettoViewPage.vue";

export default {
    ConfigurazioneContabilitaTipoDocumentiListPage,
    ConfigurazioneContabilitaCausaliTipoDocumentiListPage,
    ConfigurazioneContabilitaTabellaIvaListPage,
    ConfigurazioneContabilitaMetodiPagamentoListPage,
    ContabilitaDocumentiListPage,
    ContabilitaDocumentiEditPage,
    ContabilitaDocumentiViewPage,
    ConfigurazioneContabilitaSoggettiListPage,
    ConfigurazioneContabilitaSoggettiEditPage,
    ConfigurazioneContabilitaTipoSoggettoListPage,

    // ContabilitaDocumentiListPage,
    // ContabilitaFatturazioneView,
    // ContabilitaFatturazioneEdit,
    // TipiDocumentoList,
    // TipiDocumentoView,
    // TipiDocumentoEdit,
    // CausaliDocumentoList,
    // CausaliDocumentoView,
    // CausaliDocumentoEdit,
    // FatturazioneNumeratoriList,
    // FatturazioneNumeratoriView,
    // FatturazioneNumeratoriEdit,
    // ContabilitaDocumentiListPage,
    // ContabilitaDocumentiViewPage,
    // ContabilitaDocumentiEditPage,
    ContabilitaSoggettoListPage,
    ContabilitaSoggettoEditPage,
    ContabilitaSoggettoViewPage,
};
